import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { environment } from "../../../environments/environment";
import { Observable, of } from "rxjs";
import { Session } from '../interfaces';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class PickingCancelService {
    /**
      * Creates an instance of pick service.
      * @param apiService: ApiService
      */
    constructor(public apiService: ApiService) {
    }
    /**
     * Gets picking cancel service
     * entityId=PRO-517&fromDate=25-02-2020&toDate=30-03-2020&serialNumber&reasonId
     * @param params
     * @returns Observable<any[]>
     */
    get(params: any): Observable<any[]> {
        return this.apiService.get(`${environment.apiPicking}/orders/ordersRejected`, params);
    }
    /**
     * Gets incomplete reason
     * @returns Observable<any[]>
     */
    getIncompleteReason(): Observable<any> {
        return this.apiService.get(`${environment.apiConfiguration}/group/MISSING_REASON_CONFIG`);
    }

    /**
     * Gets incomplete reason
     * @returns Observable<any[]>
     */
     getAuditReason(): Observable<any> {
      return this.apiService.get(`${environment.apiConfiguration}/group/AUDIT_REASON_CONFIG`);
  }


    getReasons(type?:string): Observable<any[]> {
      const session: Session = JSON.parse(localStorage.getItem(environment.sessionAuth));
      if (session && session.reasons) {
        return of(session.reasons);
      } else {
        let api = `${environment.apiPicking}/incomplete/reason`;
        if(type){
          api = api + '?type=' + type
        }
      return this.apiService.get(api)
        .pipe(map(data => {
          session.reasons = data;
          localStorage.setItem(environment.sessionAuth, JSON.stringify(session));
          return data;
        }));
      }
    }
}
